import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1594117e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-3" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-4" }
const _hoisted_4 = {
  key: 1,
  class: "d-lg-flex"
}
const _hoisted_5 = { class: "mx-lg-4 d-flex align-items-center" }
const _hoisted_6 = { class: "align-middle text-center" }
const _hoisted_7 = { class: "align-middle text-center" }
const _hoisted_8 = { class: "w-25" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center fs-7"
}
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center fs-7"
}
const _hoisted_11 = { class: "align-middle text-center" }
const _hoisted_12 = { class: "align-middle text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen color-edit" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 3,
  class: "text-center fw-bold"
}
const _hoisted_20 = {
  key: 4,
  class: "d-lg-flex"
}
const _hoisted_21 = { class: "mx-lg-4 d-flex align-items-center" }
const _hoisted_22 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_28 = { class: "text-center py-4" }
const _hoisted_29 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_32 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_33 = {
  class: "modal fade",
  id: "modalSuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = { class: "modal-title w-100 fw-bold text-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_39 = { class: "text-center py-4" }
const _hoisted_40 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-12 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }

import { computed, onMounted, ref, watch } from 'vue'
import Button from '@/components/button/index.vue'
import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
//import CellSort from '@/components/cell-sort/index.vue'
import { translate } from '@/languages/i18n'
import { useRoute, useRouter } from 'vue-router'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Table from '@/components/table/index.vue'
import Loading from '@/components/loading/index.vue'
import dayjs from 'dayjs'
import TotalRecords from '@/components/total-records/index.vue'
import { ReplayName } from '@/constants/common.ts'
import notificationServices from '@/services/community-managers.services'
import { useStore } from 'vuex'
import { USER_MANAGEMENT_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)
const route = useRoute()
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route?.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('configuration'),
    to: '',
    active: false,
  },
  {
    content: translate('CF10title'),
    to: '',
    active: true,
  },
]
const router = useRouter()
const store = useStore()
const listNotification = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.LIST_NOTIFICATIONS]?.listNotifications)
// 2022/10/12 VietNC sort CF10 UAT#4425(Ph2-R20221021)
const loading = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.LIST_NOTIFICATIONS]?.loading)

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])
const currentNoticeId = ref<number>()
const currentNoticeTitle = ref<string>('')
const deleteFailed = ref<boolean>(false)
const setCurrentId = (id: number, name: string): void => {
  currentNoticeId.value = id
  currentNoticeTitle.value = name
}

// 2022/09/12 TienNV Fix Failed to delete but successful modal is displayed
const loadingButton = ref(false)
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirm'))
  modalSuccess.value = new Modal(document.getElementById('modalSuccess'))
  // 2022/10/17 VietNC sort CF10 UAT#4425(Ph2-R20221021)
  if (Object.keys(route.query).length === 0 && router.currentRoute.value.path.match('/notifications')?.length) {
    router.replace({ path: route.path, query: { publication_start_period: 'desc' } })
  }
})

const handleDelete = async (): void => {
  loadingButton.value = true
  try {
    if (route.params?.id && currentNoticeId.value) {
      const res = await notificationServices.deleteNotificationById(route.params.id, currentNoticeId.value)
      if (res.data?.success) {
        store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_LIST_NOTIFICATIONS, {
          id: route?.params?.id,
          params: {
            ...route.query,
            page: route?.query?.page || 1,
            page_of_number: route?.query?.page_of_number || 30,
          },
        })
        deleteFailed.value = false
      } else {
        deleteFailed.value = true
      }
    }
    // 2022/09/12 TienNV Fix failed to delete but successful modal is displayed
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingButton.value = false
    }, 2000)
  } catch (error) {
    deleteFailed.value = false
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loadingButton.value = false
    console.log(error)
  }
}
watch(
  () => route.query,
  async () => {
    store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_LIST_NOTIFICATIONS, {
      id: route?.params?.id,
      params: {
        ...route.query,
        page: route?.query?.page || 1,
        page_of_number: route?.query?.page_of_number || 30,
      },
    })
  },
  {
    immediate: true,
  }
)
const transitCreateNotice = () => {
  router.push(`/community/communities/${route?.params?.id}/notifications/create`)
}
const transitToEdit = (id) => {
  router.push(`/community/communities/${route?.params?.id}/notifications/${id}/edit`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CF10title')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Button, {
          title: _unref(translate)('CF10createANotice'),
          type: 'secondary',
          onClick: transitCreateNotice
        }, null, 8, ["title"])
      ]),
      (!_unref(loading))
        ? (_openBlock(), _createBlock(TotalRecords, {
            key: 0,
            totalRecords: _unref(listNotification)?.total_records
          }, null, 8, ["totalRecords"]))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(Pagination, {
                totalPage: _unref(listNotification)?.total_pages
              }, null, 8, ["totalPage"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createBlock(Table, {
            key: 2,
            columns: [
        { field: 'title', name: _unref(translate)('title'), sort: _ctx.sortField === 'title' },
        { field: 'management_no', name: _unref(translate)('managementNo'), sort: _ctx.sortField === 'management_no' },
        { field: 'customer_name', name: _unref(translate)('registrants'), sort: _ctx.sortField === 'customer_name' },
        { field: 'publication_start_period', name: _unref(translate)('CF10startDate'), sort: _ctx.sortField === 'publication_start_period' },
        { field: 'publication_end_period', name: _unref(translate)('CF10endDate'), sort: _ctx.sortField === 'publication_end_period' },
        { field: 'edit', name: _unref(translate)('edit') },
        { field: 'delete', name: _unref(translate)('delete') },
      ],
            sortCells: ['customer_name', 'title', 'management_no', 'publication_start_period', 'publication_end_period']
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listNotification)?.data?.community_notifications, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass({ rowEven: index % 2 === 0, rowDisable: _unref(dayjs)(new Date()).isSameOrAfter(_unref(dayjs)(item.publication_end_period)) }),
                  key: index
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(item.title || '-'), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.management_no || '-'), 1),
                  _createElementVNode("td", _hoisted_8, [
                    ([1, 2].includes(item?.user_type))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(item?.is_deleted_in_30_days, item?.available, item?.family_name, item?.given_name, item?.user_type)) + _toDisplayString(item?.user_type == 2 && [0, 1].includes(item?.is_deleted_in_30_days) ? `（ ${item?.display_name} ）` : ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item?.user_type === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(item?.is_deleted_in_30_days, item?.available, item?.family_name, item?.given_name, item?.user_type)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.publication_start_period !== null ? _unref(dayjs)(item.publication_start_period).format('YYYY/MM/DD HH:mm') : '-'), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.publication_end_period !== null ? _unref(dayjs)(item.publication_end_period).format('YYYY/MM/DD HH:mm') : '-'), 1),
                  _createElementVNode("td", {
                    class: "align-middle text-center cursor-pointer",
                    onClick: ($event: any) => (transitToEdit(item.id))
                  }, _hoisted_15, 8, _hoisted_13),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (setCurrentId(item.id, item.title)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalConfirm",
                    class: "cursor-pointer align-middle text-center"
                  }, _hoisted_18, 8, _hoisted_16)
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["columns"]))
        : _createCommentVNode("", true),
      (!_unref(listNotification)?.data?.community_notifications?.length && !_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(translate)('CC10noData')), 1))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createVNode(Pagination, {
                totalDataOfPage: _unref(listNotification)?.data?.community_notifications?.length,
                totalPage: _unref(listNotification)?.total_pages
              }, null, 8, ["totalDataOfPage", "totalPage"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h5", _hoisted_26, _toDisplayString(_unref(translate)('CF10titleDelete')), 1),
              _hoisted_27
            ]),
            _createElementVNode("div", _hoisted_28, "「" + _toDisplayString(currentNoticeTitle.value) + "」" + _toDisplayString(_unref(translate)('CN10textDel4')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(Button, {
                    title: _unref(translate)('deleteButton'),
                    type: 'secondary',
                    onClick: handleDelete,
                    loading: loadingButton.value,
                    disabled: loadingButton.value
                  }, null, 8, ["title", "loading", "disabled"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h5", _hoisted_37, _toDisplayString(_unref(translate)('CF10titleDelete')), 1),
              _hoisted_38
            ]),
            _createElementVNode("div", _hoisted_39, _toDisplayString(deleteFailed.value ? _unref(translate)('CE10deleteFailed') : _unref(translate)('deleteHistorySuccess')), 1),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(Button, {
                    title: _unref(translate)('close'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal"
                  }, null, 8, ["title"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: _unref(loading) }, null, 8, ["loading"])
  ], 64))
}
}

})